export function Skeleton({ className = "" }) {
  return <div className={`animate-pulse rounded-md bg-slate-200/70 ${className}`} aria-hidden />;
}

export function Card({ children, className = "", testId }) {
  return (
    <div
      data-testid={testId}
      className={`rounded-[12px] bg-white border border-slate-200/80 p-5 sm:p-6 ${className}`}
    >
      {children}
    </div>
  );
}

export function Stat({ label, value, sub, loading, testId, accent = false }) {
  return (
    <div
      data-testid={testId}
      className={`rounded-[12px] border p-5 sm:p-6 ${
        accent
          ? "bg-[#1A4232] border-[#1A4232] text-[#F5F1EB]"
          : "bg-white border-slate-200/80"
      }`}
    >
      <p className={`text-[11px] uppercase tracking-[0.16em] ${accent ? "text-[#F5F1EB]/75" : "text-slate-500"}`}>{label}</p>
      <div className={`mt-2 font-display text-[28px] leading-none ${accent ? "text-[#F5F1EB]" : "text-[#0A1128]"}`}>
        {loading ? <Skeleton className="h-7 w-24" /> : value}
      </div>
      {sub && (
        <div className={`mt-2 text-[12px] ${accent ? "text-[#F5F1EB]/80" : "text-slate-500"}`}>
          {loading ? <Skeleton className="h-3 w-32" /> : sub}
        </div>
      )}
    </div>
  );
}

export function ErrorState({ title, message, testId }) {
  return (
    <Card testId={testId} className="border-rose-200 bg-rose-50">
      <p className="font-display text-[16px] text-rose-800">{title}</p>
      <p className="mt-1 text-[13px] text-rose-700">{message}</p>
    </Card>
  );
}

export function EmptyState({ title, hint, children, testId }) {
  return (
    <Card testId={testId} className="text-center py-12">
      <p className="font-display text-[18px] text-[#0A1128]">{title}</p>
      {hint && <p className="mt-2 text-[13.5px] text-slate-600">{hint}</p>}
      {children && <div className="mt-5">{children}</div>}
    </Card>
  );
}

export function PrimaryButton({ children, testId, ...rest }) {
  return (
    <button
      data-testid={testId}
      {...rest}
      className={`inline-flex items-center gap-2 rounded-full bg-[#1A4232] text-[#F5F1EB] text-[13px] font-medium px-5 py-2.5 hover:bg-[#0E2A20] transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${rest.className || ""}`}
    >
      {children}
    </button>
  );
}

export function GhostButton({ children, testId, ...rest }) {
  return (
    <button
      data-testid={testId}
      {...rest}
      className={`inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white text-[#0A1128] text-[13px] font-medium px-4 py-2 hover:border-slate-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${rest.className || ""}`}
    >
      {children}
    </button>
  );
}
